/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { Select, Popconfirm, Tooltip } from 'antd';
import Crown from '@Images/crown2.png';
import { InfoCircleOutlined } from '@ant-design/icons';
import HideValue from '../../components/Common/RestrictedAccess/HideValue';

/**
 * PareInput custom component
 *
 */
export default function H3FormInput({
  containerClassName,
  labelClassName,
  label,
  inputClassName,
  placeholder,
  value,
  maxlength,
  pattern,
  type,
  name,
  onChange,
  onBlur,
  disabled,
  required,
  showError,
  isTextarea,
  subscript,
  noDecimal,
  onKeyUp,
  allowNegative,
  restrictInput,
  fixShowErrorCss,
  infoMessage,
  infoMessageStyle = {
    marginLeft: '5px',
    color: 'grey',
    cursor: 'pointer',
  },
  hideInput,
  popOverMessage,
}) {
  const labelHtml = label && (
    <div className={labelClassName || 'default-label'} style={{ display: 'flex', alignItems: 'center' }}>
      <div>
        {label}
        {' '}
        <span style={{ color: 'red' }}>{required ? '*' : ''}</span>
        {infoMessage && (
          <Tooltip title={infoMessage}>
            <InfoCircleOutlined
              style={infoMessageStyle}
            />
          </Tooltip>
        )}
      </div>
      {restrictInput && (
        <Popconfirm
          placement="topRight"
          title="This feature is not available in our current plan"
          onConfirm={() => window.Intercom('showNewMessage')}
          okText="Contact Us"
          cancelText="Cancel"
        >
          <img className="input-restrict" src={Crown} alt="premium" />
        </Popconfirm>
      )}
    </div>
  );
  return (
    <div className={containerClassName}>
      {labelHtml}
      {hideInput ? (
        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
          <input type="text" className={inputClassName || 'default-input'} disabled />
          <HideValue
            showPopOver
            popOverMessage={popOverMessage}
            customStyle={{
              position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)',
            }}
          />
        </div>
      ) : (
        <React.Fragment>
          {isTextarea
            ? (
              <textarea
                placeholder={placeholder}
                value={value}
                maxLength={maxlength}
                onChange={onChange}
                type={type}
                name={name}
                onKeyUp={onKeyUp}
                className={inputClassName || 'default-input'}
                disabled={disabled}
                onBlur={onBlur}
                rows={4}
              />
            )
            : (
              <input
                placeholder={placeholder}
                value={value}
                maxLength={maxlength}
                pattern={pattern}
                onChange={onChange}
                type={type}
                name={name}
                onKeyUp={onKeyUp}
                className={inputClassName || 'default-input'}
                disabled={disabled}
                onBlur={onBlur}
                min={allowNegative ? '' : '0'}
                step={noDecimal}
                onWheel={(event) => event.target.blur()}
              />
            )}
          {subscript && (
            <div className="input-subscript">
              {subscript}
            </div>
          )}
          {showError && (
            <div className={!fixShowErrorCss ? 'input-error' : 'fixed-input-css'}>
              *Please enter
              {` ${name}`}
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
}

H3FormInput.propTypes = {
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  maxlength: PropTypes.string,
  pattern: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  showError: PropTypes.any,
  disabled: PropTypes.bool,
  isTextarea: PropTypes.bool,
  subscript: PropTypes.any,
};
